import { ConnectionAddressObject } from '@origin-digital/address-lookup';

export const invalidAddressMessage = "Oops, that address doesn't look right...";
export const pleaseEnterAddressMessage = 'Please enter your connection address...';

export const validate = (
  address: ConnectionAddressObject | undefined,
  inputValue?: string,
): string => {
  if (!address) {
    if (inputValue) {
      return invalidAddressMessage;
    } else {
      return pleaseEnterAddressMessage;
    }
  }
  return '';
};
